var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.user &&
    ([
      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
      'DIRECTIVOS ACADÉMICOS (CAMPUS)',
      'DIRECTIVOS FACULTAD O ESCUELA',
      'DIRECTORES DE CARRERA',
      'DIRECTORES DE CARRERA (CAMPUS)',
      'ADMINISTRATIVOS INSTRUCCIONALES',
      'PROFESORES',
    ].some((group) => _vm.user.group_names.includes(group)) ||
      _vm.user.is_superuser)
  )?_c('div',[(
      _vm.show_button_ai &&
      _vm.allows_crud &&
      _vm.user &&
      (_vm.user.user_data == null ||
        (_vm.user.user_data && _vm.user.user_data.ai_component))
    )?[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.sidebar-right",modifiers:{"sidebar-right":true}}],staticClass:"new-btn-ai noprint",class:{ 'kl-rail--expanded': _vm.expanded },attrs:{"title":"IA"}},[_c('img',{staticClass:"new-icon-btn-ai",attrs:{"src":require("../../../assets/icon-ai.svg"),"alt":""}}),(_vm.expanded == true)?_c('span',{staticClass:"ai-text ml-2"},[_vm._v(" "+_vm._s(_vm.$t("reusable.aiComponent.artificialIntelligence"))+" ")]):_vm._e()])]:_vm._e(),_c('AiSidebar')],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }